import DashboardShowContainer from './dashboard_show_container';

const DashboardShow = DashboardShowContainer;

export default DashboardShow;
